import { useState } from 'react'
import type { ScreenProps } from './screens'
import { assetUrl } from '../ui/assetUrl'

/**
 * Privirea de ansamblu asupra unei masini - inventoree/devices/others/
 * deviceOverview.php cu gesturile din device_workspace.js: modulele ca un
 * acordeon orizontal, unul singur desfacut (implicit cel din care s-a venit,
 * altfel primul), celelalte stranse ca dungi; continutul unui modul se cere
 * abia cand i se desface dunga, si o singura data.
 */
export function DeviceOverview({ id, from, overview, screen }: ScreenProps) {
  const fallback = overview[0]?.slug ?? ''
  const [open, setOpen] = useState(() => (overview.some((m) => m.slug === from) ? from : fallback))
  const [loaded, setLoaded] = useState<Set<string>>(() => new Set(open ? [open] : []))

  const show = (slug: string) => {
    if (slug === open) return
    setOpen(slug)
    setLoaded((s) => (s.has(slug) ? s : new Set(s).add(slug)))
  }

  return (
    <div className="device-overview" data-device={id}>
      {overview.map((m) => {
        const isOpen = m.slug === open
        return (
          <section key={m.slug} className={`dov-panel${isOpen ? ' is-open' : ''}`} data-module={m.slug} data-summary={`/app/${m.summary}${id}`}>
            <header className="dov-spine" style={{ backgroundColor: m.color }} onClick={() => show(m.slug)}>
              <span className="dov-logo">
                <img src={assetUrl(`images/header/${m.icon}`)} alt="" width={18} height={18} />
              </span>
              <span className="dov-name">{m.name}</span>
              <i className="fas fa-chevron-right dov-hint" aria-hidden="true"></i>
            </header>

            <div className="dov-head" style={{ backgroundColor: m.color }}>
              <span className="dov-logo">
                <img src={assetUrl(`images/header/${m.icon}`)} alt="" width={18} height={18} />
              </span>
              <span className="dov-head-name">{m.name}</span>
            </div>

            <div className="dov-body" style={isOpen ? undefined : { display: 'none' }}>
              {loaded.has(m.slug) ? screen(m.summary, `${m.name} Summary`) : <div className="dov-loading">Loading...</div>}
            </div>
          </section>
        )
      })}
    </div>
  )
}
